import React, { FC } from 'react'
import Person from '@mui/icons-material/Person'
import { Event } from '../types'

type VendorDetailsProps = {
  event: Event
}

const VendorDetails: FC<VendorDetailsProps> = ({ event }) => {
  if (!event.contact) return null

  return (
    <div className="tw:p-4 tw:pt-6 tw:flex tw:flex-col tw:items-center tw:bg-white tw:rounded-4xl tw:border tw:border-neutrals-300">
      <div className="tw:text-sm tw:font-semibold tw:text-tertiary-black tw:w-full">{'Vendor details'}</div>
      <div className="tw:w-full tw:mt-4">
        <div className="tw:flex tw:gap-4 tw:items-center tw:text-sm tw:font-semibold tw:py-2">
          <div className="tw:size-8 tw:bg-neutrals-200 tw:shrink-0 tw:rounded-full tw:flex tw:items-center tw:justify-center">
            <Person className="tw:!size-5" />
          </div>
          <div className="tw:grow">{event.contact.company_name}</div>
        </div>
      </div>
    </div>
  )
}

export default VendorDetails
